import { render } from "./ContractsView.vue?vue&type=template&id=87b266fe"
import script from "./ContractsView.vue?vue&type=script&lang=js"
export * from "./ContractsView.vue?vue&type=script&lang=js"

import "./ContractsView.vue?vue&type=style&index=0&id=87b266fe&lang=css"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__